<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.cutting.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.carting.wagons' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.cutting.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.name.label' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.cutting.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['batchType'].invalid && controls['batchType'].touched) {
				<mat-error>{{ 'masterdata.cutting.dialog.batch-type.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.cutting.dialog.batch-type.label' | translate }}</mat-label>
				<input maxlength="255" matInput formControlName="batchType" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.carting.dialog.cells.label' | translate }}</mat-label>
				@if (controls['cells']?.errors?.['max'] && controls['cells'].touched) {
				<mat-error>{{ 'masterdata.carting.dialog.cells.errors.max' | translate }}</mat-error>
				} @if (controls['cells']?.errors?.['required'] && controls['cells'].touched) {
				<mat-error>{{ 'masterdata.carting.dialog.cells.errors.empty' | translate }}</mat-error>
				}
				<input OnlyNumbers matInput formControlName="cells" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.carting.types.label' | translate }}</mat-label>
				<mat-select formControlName="type">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (state of translationTypes; track state) {
					<mat-option [value]="state">{{ ('masterdata.carting.types.' + getComponent(state)) | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.carting.layers.label' | translate }}</mat-label>
				<mat-select formControlName="layer">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (state of translationLayers; track state) {
					<mat-option [value]="state">{{ ('masterdata.carting.layers.' + getComponent(state)) | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.cutting.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.cutting.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
